<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">AGV名称：</span>
        <el-input v-model="search.agvName" :size="size" clearable placeholder="请输入AGV名称"></el-input>
      </div>
      <div class="header_item">
        <span class="header_label">时间范围：</span>
        <el-date-picker
            v-model="search.time"
            type="daterange"
            :default-time="['00:00:00','23:59:59']"
            clearable
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="-"
            start-placeholder="起始时间"
            end-placeholder="结束时间">
        </el-date-picker>
      </div>
      <div class="header_item">
        <el-button   :size="size" icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="时间" align="center" ></el-table-column>
        <el-table-column prop="agvId" label="AGV名称" align="center" ></el-table-column>
        <el-table-column prop="agvWorkingState" label="AGV状态" align="center" >
            <template #default="{row}">
                <div>{{row.agvWorkingState ==='idle'?'空闲状态':row.agvWorkingState ==='busy'?'繁忙状态':row.agvWorkingState ==='error'?'故障状态':""}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="agvJackingState" label="顶升机构状态" align="center" >
            <template #default="{row}">
                <div>{{row.agvJackingState ==='jackingUp'?'液压顶升':row.agvJackingState ==='jackingDown'?'液压下降':row.agvJackingState ==='jackingMiddle'?'液压中间位置':""}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="agvLiftupHeavyState" label="是否存在重物" align="center" >
            <template #default="{row}">
                <div>{{row.agvLiftupHeavyState ==='heavyExistence'?'存在模具':row.agvLiftupHeavyState ==='heavyNoExistence'?'不存在模具':""}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="agvTaskState" label="AGV任务状态" align="center" >
            <template #default="{row}">
                <div>{{row.agvTaskState ==='idle'?'空闲状态':row.agvTaskState ==='busy'?'繁忙状态':row.agvTaskState ==='error'?'故障状态':""}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="agvCurrentLandmarkRFID" label="AGV当前位置" align="center" ></el-table-column>
        <el-table-column prop="battery1Voltage" label="电压" align="center"></el-table-column>
        <el-table-column prop="battery1Current" label="电流" align="center"></el-table-column>
        <el-table-column prop="battery1Charge" label="电量" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia/index';
import { changeSize } from '../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        loading: false,
        dataList: [], //AGV监控
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.ruleForm.resetFields();
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchButtonInfo(true);
    },
    methods: {
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
            pageNum: this.pageNum,
            pageSize: this.pageSize
        })
        params.startDate = this.search.time==null?'':this.search.time&&this.search.time[0]
        params.endDate = this.search.time==null?'':this.search.time&&this.search.time[1]
        delete params.time
        this.loading = true;
        this.$api.DuctpiecePLM.searchAgvLists(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="sass" scoped>
@import '../../style/layout-main.scss';
</style>